import { useLoggedInUser } from 'hooks/useLoggedInUser'
import { CustomerRole } from 'types/gql-global-types'

export const useAccountsIsAllowed = () => {
  const { userRole } = useLoggedInUser()
  const isAdmin = userRole === CustomerRole.ADMIN
  return isAdmin
}
